import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import R from 'ramda'
import classNames from 'classnames'

import {
  getImageNode,
} from 'utils/selectors'

import { postEnhancer } from 'utils/enhancers'
import Title from 'components/Title'

const isEven = n => n % 2 == 0
const isOdd = n => Math.abs(n % 2) == 1

const buildClass = (index, className) => classNames({
  'md-col-6 md-flex items-center bg-cover bg-center': true,
  'order-1': isEven(index),
  'order-2': isOdd(index),
  [className]: className
})

const BlogIndex = ({ posts, siteTitle }) => (
  <div className='flex flex-auto'>
    <Helmet title={siteTitle} />
    
    <div className='sm-flex flex-wrap'>
      {posts.map((post, index) => (
        <Link 
          key={post.node.frontmatter.path}
          to={post.node.frontmatter.path}
          className='sm-col-6 md-flex block text-decoration-none bg-black white'
          style={{
            backgroundColor: [
              '#1C5D99',
              '#222222',
              '#222222',
              '#1C5D99',
            ][index]
          }}
        > 
          <div 
            className={buildClass(index, 'bg-tile')}
            style={{
              backgroundImage: `url(${getImageNode(post.node)})`
            }}
          />

          <div className={buildClass(index, 'border-box p2')}>
            <div>
              <h1 className='h2 lg-h1 bold mt0 mb1 line-height-1'>
                {get(post, 'node.frontmatter.title')}
              </h1>
              <p className='my0 h4 md-h5 lg-h4'>
                {get(post, 'node.frontmatter.summary')}
              </p>
            </div>
            
          </div>
        </Link>
      ))}
    </div>

  </div>
)

BlogIndex.propTypes = {
  route: React.PropTypes.object,
}

export default postEnhancer(BlogIndex)

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      filter: { frontmatter: { category: { eq: "lesson" }}}
      sort: { fields: [frontmatter___order], order: ASC }
    ) {
      edges {
        node {
          frontmatter {
            path
            title
            date
            summary
            image {
              childImageSharp {
                responsiveSizes(maxWidth: 2500, quality: 70) {
                  src
                }
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js